import React, { useRef } from 'react'
import insEmpty from 'image/empty_ins.png'
import { PicturePreview } from 'baseComponent'
import Upload from 'meinian-package/src/component/upload/image'
import { Li, Empty } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import MNWaterfall from 'component/waterfall/baseMasonry'
import { useUpdate } from 'ahooks'
import { ossImg } from 'meinian-package/src/utils/image'
import Input from 'meinian-package/src/baseComponent/input'
import Modal from 'meinian-package/src/component/modal'
import Icon from 'meinian-package/src/component/icon'
import LoadMore from 'meinian-package/src/component/loadmore'
import SimpleImage, { Image } from './simpleImage'
import './index.less'

const MAX_SELECT_COUNT = 20
const MAX_FILE_SIZE = 3
const MAX_FILE_COUNT = 30

export default ({
  visible,
  setVisible,
  setTempValue,
  images,
  onChange,
  tempValue,
  $list,
  onChangeKey,
  keyWords,
  setcurrentIdeaMassId,
  currentIdeaMassId,
  recentIdeaMasses,
  insList,
  onLoad,
  isEnd,
  loading,
  isEmpty,
  events,
  count,
  doneCount,
  materials,
}) => {
  const $masonry = useRef()
  const onUpdate = useUpdate()
  const onDelete = async (item) => {
    const currentIndex = materials?.resultList.findIndex(i => i.materialId === item.materialId)
    if (currentIndex !== -1) {
      materials?.resultList.splice(currentIndex, 1)
      const result = await request.get('/zhikuan/materials/delete-material', { params: { materialId: item.materialId } })
      if (result) {
        $masonry.current?.layout()
        onUpdate()
      }
    }
  }
  const listDomRef = useRef()

  const renderList = () => {
    if (isEmpty) {
      return <Empty />
    } if (currentIdeaMassId) {
      return <div style={{ width: 556 }}>
        <MNWaterfallApi
          root={listDomRef.current}
          renderItem={SimpleImage}
          idKey={['imageGroupEntityId', 'inspirationId']}
          url="/image-bus/inspiration/list-blog"
          method="post"
          pageSize={50}
          params={{
            qualityFlag: 0,
            duplicateFilter: 0,
            subscribeType: 0,
            browseAddress: 1,
            inspirationId: currentIdeaMassId,
            currentIdeaMassId
          }}
          emptyText="暂无相关款式图"
          emptyType="image"
          columnCount={5}
          gutter={8}
          cardKey={(i) => i.imageGroupEntityId}
          cardProps={{
            selectedData: tempValue,
            onClickCard: m => events.onClickImg(m),
            hiddenClose: currentIdeaMassId,
          }}
        />
      </div>
    }
    return <div>
      <div style={{ fontSize: 12, color: 'var(--m-text-3)', textAlign: 'right', marginBottom: 16, marginRight: 21 }}>
        仅支持{MAX_FILE_SIZE}MB以内的JPG、JPEG、PNG格式图片上传
        <Upload
          onSuccess={(result) => {
            result.forEach(item => {
              events.onUpload(item.url, item.filename, result)
            })
          }}
          onUploadProgress={(progressFiles, files) => {
            events.onUploadProgress(files)
          }}
          multiple
          style={{ display: 'inline-block', marginLeft: 8 }}
          customDir="data_infra/26/"
          maxSize={MAX_FILE_SIZE}
          maxCount={MAX_FILE_COUNT}
        >
          <Button>上传图片</Button>
        </Upload>
      </div>
      {(count > 0 && doneCount !== count) && <div className="progress">
        正在上传{doneCount}/{count}
        </div>}
      <div style={{ width: 556 }}>
        <MNWaterfall
          renderItem={(item, width) => <SimpleImage
            itemData={item}
            mainUrl={item.mainUrl}
            columnWidth={width}
            data={materials?.resultList}
            key={item.imageGroupEntityId}
            onDeleteItem={() => onDelete(item)}
            selectedData={tempValue}
            onClickCard={() => events.onClickImg(item)}
            hiddenClose={currentIdeaMassId}
          />}
          data={materials?.resultList}
          emptyText="暂无相关款式图"
          emptyType="image"
          columnCount={5}
          gutterSize={8}
          instance={$masonry}
        />
      </div>
    </div>
  }

  return <Modal
    title="添加款式图库"
    uiOne
    style={{ width: 826, height: 600 }}
    wrapStyle={{ zIndex: 1001 }}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    onCancel={() => { setTempValue(images) }}
    onOk={() => onChange(tempValue)}
    className="meinian-image-gallery-add-modal"
  >
    <div className="add-image-wrapper">
      <div className="aside" ref={$list}>
        <Input.Search
          placeholder="搜索灵感集"
          onChange={onChangeKey}
          maxLength={20}
          wrapStyle={{ width: 224, margin: '2px 0 4px 8px' }}
        />
        {keyWords ? null : <Li
          className="idea-mass-item"
          onClick={() => setcurrentIdeaMassId(null)}
          active={!currentIdeaMassId}
        >我的素材</Li>}
        {keyWords ? null : <div>
          <Li className="idea-mass-item notClickable">最近使用</Li>
          {recentIdeaMasses?.map(m => <Li
            onClick={() => setcurrentIdeaMassId(m.id)}
            className="idea-mass-item line-1"
            active={currentIdeaMassId === m.id}
          >{m.name}</Li>)}
        </div>}
        <div>
          <Li className="idea-mass-item notClickable">全部灵感集</Li>
          {insList?.length ? insList?.map(ins => <Li
            onClick={() => setcurrentIdeaMassId(ins.id)}
            className="idea-mass-item line-1"
            active={currentIdeaMassId === ins.id}
            style={{ width: '100%', height: 40 }}
          >{ins.name}</Li>) : <div className="ins-empty"><img src={insEmpty} />暂无相关灵感集</div>}
          <LoadMore onLoad={onLoad} stop={isEnd} loading={loading} observerParams={{ root: $list.current }}>
            {loading ? <div style={{ height: 48, textAlign: 'center', paddingTop: 10 }}>加载中...</div> : null}
          </LoadMore>
        </div>
      </div>
      <div className="images" ref={listDomRef}>
        {renderList()}
      </div>
    </div>
    <div className="mn-image-gallery-select-list">
      {tempValue.map(m => <Image
        src={ossImg(m.mainUrl, 300, 300)}
        className="img"
        onClick={() => PicturePreview.show({ src: m.mainUrl, picWidth: m.width, picHeight: m.height })}
        width={60}
        height={60}
        key={m}
      >
        <Icon type="m-jianshao_tianchong" onClick={e => events.onDelTempValue(m, e)} className="del" />
      </Image>)}
    </div>
    <div className="modal-footer-slot">
      <span>已选择 {tempValue.length}/{MAX_SELECT_COUNT} 项</span>
    </div>
  </Modal>
}
